import { register } from "@rill/loader";

// Door access (FaciliKey) reads. A 403 is a real answer (the caller may not see
// door data) and is cached like any other: `{ forbidden: true }`. Any other
// failure throws, so it is never cached and a retry hits the API again; the
// controllers turn it into `{ error: true }` with tryLoad.
//
// Live data (status, Logs) uses ttl 0, which never serves a session-cached
// answer. Aggregates keep a short ttl with "no-bust": door events arrive from
// a webhook and do not bump msb-api's last-modified, so the ttl is the only
// expiry. Door names are the exception: msb-api bumps "gym-door" when they
// change.
const fetchDoor = async (api, path, query) => {
  const res = await api(path, { query });
  if (res.status === 403) return { forbidden: true };
  if (!res.ok) throw new Error(`${path} ${res.status}`);
  return res.json();
};

register({ name: "doorAccessStatus", ttl: 0 }, async ({ api }) =>
  fetchDoor(api, "door-access-status")
);

register(
  { name: "doorLastIn", meta: ["no-bust"], ttl: "5 minutes" },
  async ({ api }) => fetchDoor(api, "door-last-in")
);

register(
  { name: "doorMemberSummary", meta: ["no-bust"], ttl: "2 minutes" },
  async ({ api }, { memberId }) => ({
    memberId,
    ...(await fetchDoor(api, "door-member-summary", { memberId })),
  })
);

register(
  { name: "doorClientVisits", meta: ["no-bust"], ttl: "5 minutes" },
  async ({ api }, { clientId, range }) => ({
    clientId,
    ...(await fetchDoor(api, "door-client-visits", {
      clientId,
      ...(range && { range }),
    })),
  })
);

register(
  { name: "gymDoors", meta: ["no-bust", "gym-door"], ttl: "1 hour" },
  async ({ api }) => fetchDoor(api, "gym-doors")
);

register({ name: "doorLogs", ttl: 0 }, async ({ api }, query) =>
  fetchDoor(api, "door-logs", query)
);

register({ name: "doorLogsSummary", ttl: 0 }, async ({ api }, query) =>
  fetchDoor(api, "door-logs-summary", query)
);

register(
  { name: "doorBusyTimes", meta: ["no-bust"], ttl: "5 minutes" },
  async ({ api }, query) => fetchDoor(api, "door-busy-times", query)
);
